import { useEffect, useState } from 'react';
import { api } from '../api';
import { Reason } from '../data/Reason';

export function useReasonList() {
    const [reasonList, setReasonList] = useState<Reason[]>([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        api.reason()
            .then((resData) => {
                setLoading(false);
                setReasonList(resData);
            }).catch(() => {
                setLoading(false);
            });
    }, []);

    return {
        reasonList,
        isLoading,
    };
}
